import { useAccount } from "@azure/msal-react";
import { datadogRum } from "@datadog/browser-rum";
// eslint-disable-next-line import/no-unresolved
import formbricks from "@formbricks/js";
import MD5 from "crypto-js/md5";
import * as React from "react";
import { getLanguageObjectBasedOnLocale, getUserPreferredLanguage } from "../../helper";
import Role from "../permissions/Role";
import { getRoles, isTestEnv } from "../utils/utils";

const UserTracking: React.FC = () => {
  const activeAccount = useAccount();
  const roles = getRoles();
  const userId = activeAccount ? MD5(activeAccount.username).toString() : "unknown";

  // DATADOG
  datadogRum.setUser({
    id: userId,
    roles: getRoles(),
    language: getUserPreferredLanguage(),
  });

  // Google Analytics
  if (process.env.NODE_ENV === "production") {
    window.dataLayer = window.dataLayer || [];

    // User Dimension for Roles
    if (roles) {
      window.dataLayer.push(
        { isAdmin: roles.includes(Role.ROLE_ADMIN) },
        { isBd: roles.includes(Role.ROLE_BD) },
        { isOp: roles.includes(Role.ROLE_OP) },
        { isUserManager: roles.includes(Role.ROLE_USER_MANAGER) },
        { isCapacityManager: roles.includes(Role.ROLE_CAPACITY_MANAGER) },
        { isGeneralSettings: roles.includes(Role.ROLE_GENERAL_SETTINGS) },
        { isPricing: roles.includes(Role.ROLE_PRICING) },
        { isScheduleManager: roles.includes(Role.ROLE_SCHEDULE_MANAGER) },
        { isReporting: roles.includes(Role.ROLE_REPORTING) },
        { isPartner: roles.includes(Role.ROLE_PARTNER) },
        { isStationManager: roles.includes(Role.ROLE_STATION_MANAGER) },
        { isPowerBi: roles.includes(Role.ROLE_POWER_BI) },
        { isDispatcher: roles.includes(Role.ROLE_DISPATCHER) },
        { isDriver: roles.includes(Role.ROLE_DRIVER) }
      );
    }
  }

  // Formbricks
  if (typeof window !== "undefined" && !isTestEnv()) {
    formbricks.setup({
      environmentId: "cmgqim9gf034xkm01ehg9llac",
      appUrl: "https://surveys.cro.flix.tech",
    });

    // User is not registered yet
    if (localStorage.getItem("formbricks-js") == null) {
      formbricks.setLanguage(getLanguageObjectBasedOnLocale(getUserPreferredLanguage(), true).iso6391);
      formbricks.setUserId(userId);
      formbricks.setAttributes({
        Roles: roles ? roles.join(";") : "",
      });
    }
  }

  return <></>;
};

export default UserTracking;
